// extracted by mini-css-extract-plugin
export default {"CharacterCounter":"CharacterCounter_CharacterCounter__0FZqd","OffLimit":"CharacterCounter_OffLimit__f0k8h","CloseToLimit":"CharacterCounter_CloseToLimit__ErqoI"};